<template>
  <v-container v-if="user && currentUser" fill-height fluid pa-10>
    <v-row align="center" justify="center">
      <h2 class="text-center">
        Hola {{ this.currentUser.nombre }}, Bienvenido a la página de ventas
        movil de Prostasa S.A. de C.V.
      </h2>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/pedidos"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/write-order-order-online-shop-svgrepo-com.svg"
            alt="Pedidos"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Pedidos</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/precios_existencias"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/outline-price-red-svgrepo-com.svg"
            alt="Precios y Existencias"
            style="height: 90px; margin-bottom: 8px"
          />
          <span>Precios y Existencias</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/clientes"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/user-svgrepo-com.svg"
            alt="Clientes"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Clientes</span>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" offset-md="1" class="mt-4">
        <v-btn
          color="glass-effect"
          link
          to="/mis_clientes"
          style="
            min-width: 150px;
            height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <img
            src="@/assets/user-tie-svgrepo-com.svg"
            alt="Mis Clientes"
            style="height: 100px; margin-bottom: 8px"
          />
          <span>Mis Clientes</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
  },
};
</script>

<style scoped>
.glass-effect {
  border-radius: 10px;
  background-color: rgba(3, 51, 197, 0.3);
  border: 1px solid rgba(98, 97, 97, 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 0 10px rgba(1, 51, 205, 0.3);
  transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    backdrop-filter 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}
</style>
